import { css } from '@emotion/core';
import { StyledColumnWrapper } from './styles';
export default (function (theme) {
  return /*#__PURE__*/css("--column-margin--side:1.8em;.--shadow{box-shadow:0 10px 25px 0 rgba(0,0,0,0.43);}", StyledColumnWrapper, "{border-radius:0.5em;}");
});